import * as types from '../../mutation_types';
import { https,httpsFile } from './http';
import * as itemService from "./item.js";

const state = {
    loading:false,
    id:'',
    page:1,
    currentpage:5,
    search:'',
    company:'',
    storage_location:'',
    errors:'',
    offtake:false,
    lastmonth:false,
    inventory:false,
    onorder:false,
    discount:false,
    discount_loading:false,
    data:{},
    matnr:'',
    det_loading:false,
    offtakedata:[],
    lastmonthdata:[],
    inventorydata:[],
    onorderdata:[],
    discountdata:[],
    update_details:new FormData(),
    update_return: {},
    item_id:'',
    discounterror:'',
    item:'',
    add_item:false,
    add_item_loading:false,
    add_item_data:{},
    add_item_form_data:new FormData(),
    add_items:new FormData(),
    add_item_error:''
};
const getters = {
    loading:state=>state.loading,
    id:state=>state.id,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    search:state=>state.search,
    company:state=>state.company,
    storage_location:state=>state.storage_location,
    errors:state=>state.errors,
    offtake:state=>state.offtake,
    lastmonth:state=>state.lastmonth,
    inventory:state=>state.inventory,
    onorder:state=>state.onorder,
    discount:state=>state.discount,
    overall_discount:state=>state.overall_discount,
    discount_loading:state=>state.discount_loading,
    data:state=>state.data,
    matnr:state=>state.matnr,
    det_loading:state=>state.det_loading,
    offtakedata:state=>state.offtakedata,
    lastmonthdata:state=>state.lastmonthdata,
    inventorydata:state=>state.inventorydata,
    onorderdata:state=>state.onorderdata,
    discountdata:state=>state.discountdata,
    update_details:state=>state.item_details,
    update_return:state=>state.update_return,
    item_id:state=>state.item_id,
    discounterror:state=>state.discounterror,
    item:state=>state.item,
    add_item:state=>state.add_item,
    add_item_loading:state=>state.add_item_loading,
    add_item_data:state=>state.add_item_data,
    add_item_form_data:state=>state.add_item_form_data,
    add_items:state=>state.add_items,
    add_item_error:state=>state.add_item_error
};
const actions = {
    async fetchPostPoDetails({commit}){
        commit(types.REL_DET_LOADING);
        let company = state.company;
        let uri = `post-po-detail/${state.id}?page=${state.page}&currentpage=${state.currentpage}&search=${state.search}&company=${state.company}&storage_location=${state.storage_location}`;
        await https().get(uri).then(async function(val){
            // await $.each(val.data.data, async function (key, value) {
            //     // let item_det = await itemService.create(value.matnr, company);
            //     // value.lastpoprice = 0;
            //     // if(Number(item_det.data.PRICE) > 0){
            //     //     value.lastpoprice = item_det.data.PRICE;
            //     // }
            //     commit(types.REL_DET_DATA,val.data);
            // });

            let user = JSON.parse(localStorage.getItem('user'));
            if(user.user.company_code == '1901'){
                for(const item of val.data.data){
                    item.offtake = item.total_offtake;
                    item.last_month = item.total_last_month;
                    item.on_order = item.total_on_order;
                    item.inventory = item.total_inventory;
                }
            }

            commit(types.REL_DET_DATA,val.data);
            commit(types.REL_DET_LOADING);
        }).catch(error=>{
            commit(types.REL_DET_ERROR,'Internal Server Error');
            commit(types.REL_DET_LOADING);
        });




    },
    async offtake({commit}){
        commit(types.REL_DET_MAT_LOADING);
        let uri = `offtake/${state.matnr}`;
        await https().get(uri).then(response=>{
            commit(types.REL_DET_OFFTAKEDATA,response.data);
            commit(types.REL_DET_MAT_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.REL_DET_MAT_LOADING);
        })
    },
    async lastmonth({commit}){
        commit(types.REL_DET_MAT_LOADING);
        let uri = `lastmonth/${state.matnr}`;
        await https().get(uri).then(response=>{
            commit(types.REL_DET_LASTMONTHDATA,response.data);
            commit(types.REL_DET_MAT_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.REL_DET_MAT_LOADING);
        })
    },
    async inventory({commit}){
        commit(types.REL_DET_MAT_LOADING);
        let uri = `inventory/${state.matnr}`;
        await https().get(uri).then(response=>{
            commit(types.REL_DET_INVENTORYDATA,response.data);
            commit(types.REL_DET_MAT_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.REL_DET_MAT_LOADING);
        })
    },
    async onorder({commit}){
        commit(types.REL_DET_MAT_LOADING);
        let uri = `onorder/${state.matnr}`;
        await https().get(uri).then(response=>{
            commit(types.REL_DET_ONORDERDATA,response.data);
            commit(types.REL_DET_MAT_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.REL_DET_MAT_LOADING);
        })
    },
    async updateItem({commit}){
        let uri = `post-po-detail/${state.id}`;
        await https().post(uri,state.update_details).then(response=>{
            commit(types.REL_DET_UPDATE_RETURN,response.data);
        }).catch(error=>{
            console.log(error);
            let response = {
                status:'error',
                message:'Internal Server Error'
            };
            commit(types.REL_DET_UPDATE_RETURN,response);
        })
    },
    async fetchDiscounts({commit}){
        commit(types.REL_DET_DISCOUNT_LOADING);
        commit(types.REL_DET_DISCOUNT_DETAILS,state.data.data[state.item_id].discount);
        commit(types.REL_DET_DISCOUNT_LOADING);
    },
    async updateDiscount({commit}){
        commit(types.REL_DET_ERR_DISCOUNT,'');
        $.each(state.discountdata,(key,value)=>{
            if(value.type==='' || value.value===''){
                commit(types.REL_DET_ERR_DISCOUNT,'Value and Type should not be empty.');
            }
        })
        if(state.discounterror===''){
            let uri = `discounts/${state.item}`;
            let form_data = new FormData();
            form_data.append('discounts',JSON.stringify(state.discountdata));
            form_data.append('_method','put');
            await https().post(uri,form_data).then(response=>{
                commit(types.REL_DET_ERR_DISCOUNT,'');
            }).catch(error=>{
                console.log(error);
                commit(types.REL_DET_ERR_DISCOUNT,'Internal server error.');
            })
        }
    },
    async fetchMaterials({commit}){
        let uri = `material-master`;
        commit(types.REL_DET_ADD_ITEM_LOADING);
        await https().post(uri,state.add_item_form_data).then(response=>{
            commit(types.REL_DET_ADD_ITEM_DATA,response.data);
            commit(types.REL_DET_ADD_ITEM_LOADING);
        }).catch(error=>{
            console.log(error)
            commit(types.REL_DET_ADD_ITEM_LOADING);
        })
    },
    async addMaterials({commit}){
        let uri = `post-po-detail`;
        await https().post(uri,state.add_items).then(response=>{
            let status = response.data.status;
            switch(status){
                case 'success':
                    commit(types.REL_DET_ADD_ITEM_ERROR,'');
                    break;
                case 'error':
                    commit(types.REL_DET_ADD_ITEM_ERROR,message)
                    break;
            }
        }).catch(error=>{
            let message = 'Internal Server Error';
            commit(types.REL_DET_ADD_ITEM_ERROR,message)
        })
    }
};
const mutations = {
    [types.REL_DET_ID](state,data){
        state.id = data;
    },
    [types.REL_DET_PAGE](state,data){
        state.page = data;
    },
    [types.REL_DET_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.REL_DET_LOADING](state){
        state.loading = !state.loading;
    },
    [types.REL_DET_SEARCH](state,data){
        state.search = data;
    },
    [types.REL_DET_COMPANY](state,data){
        state.company = data;
    },
    [types.REL_DET_STORLOC](state,data){
        state.storage_location = data;
    },
    [types.REL_DET_DATA](state,data){
        state.data = data;
    },
    [types.REL_DET_ERROR](state,data){
        state.error = data;
    },
    [types.REL_DET_OFFTAKE](state){
        state.offtake = !state.offtake;
    },
    [types.REL_DET_LASTMONTH](state){
        state.lastmonth = !state.lastmonth;
    },
    [types.REL_DET_INVENTORY](state){
        state.inventory = !state.inventory;
    },
    [types.REL_DET_ONORDER](state){
        state.onorder = !state.onorder;
    },
    [types.REL_DET_MATNR](state,data){
        state.matnr = data;
    },
    [types.REL_DET_MAT_LOADING](state){
        state.det_loading = !state.det_loading;
    },
    [types.REL_DET_OFFTAKEDATA](state,data){
        state.offtakedata = data;
    },
    [types.REL_DET_LASTMONTHDATA](state,data){
        state.lastmonthdata = data;
    },
    [types.REL_DET_ONORDERDATA](state,data){
        state.onorderdata = data;
    },
    [types.REL_DET_INVENTORYDATA](state,data){
        state.inventorydata = data;
    },
    [types.REL_DET_UPDATE_DETAILS](state,data){
        state.update_details = data;
    },
    [types.REL_DET_UPDATE_RETURN](state,data){
        state.update_return = data;
    },
    [types.REL_DET_DISCOUNT](state){
        state.discount = !state.discount;
    },
    [types.REL_DET_DISCOUNT_DETAILS](state,data){
        state.discountdata = data;
    },
    [types.REL_DET_DISCOUNT_LOADING](state){
        state.discount_loading = !state.discount_loading;
    },
    [types.REL_DET_ITEM_ID](state,data){
        let index = state.data.data.findIndex((details)=>details.id == data);
        state.item_id = index;
        state.item = data;
    },
    [types.REL_DET_ADD_DISCOUNT](state){
        state.discountdata.push({
            detail_id:state.item,
            type:'',
            value:''
        })
    },
    [types.REL_DET_DEL_DISCOUNT](state,index){
        state.discountdata.splice(index,1);
    },
    [types.REL_DET_EDIT_DISCOUNT](state,data){
        let id = data.id;
        let type = data.type;
        state.discountdata[id].type = type;
    },
    [types.REL_DET_ERR_DISCOUNT](state,data){
        state.discounterror = data;
    },
    [types.REL_DET_UPDATE_DISCOUNTS](state,overall_discount){
        let data = updateItems(overall_discount)
        state.data = data;
    },
    [types.REL_DET_ADD_ITEM](state){
        state.add_item = !state.add_item;
    },
    [types.REL_DET_ADD_ITEM_LOADING](state){
        state.add_item_loading = !state.add_item_loading
    },
    [types.REL_DET_ADD_ITEM_DATA](state,data){
        state.add_item_data = data;
    },
    [types.REL_DET_ADD_ITEM_FORM_DATA](state,data){
        state.add_item_form_data = data;
    },
    [types.REL_DET_ADD_ITEMS](state,data){
        state.add_items = data;
    },
    [types.REL_DET_ADD_ITEM_ERROR](state,data){
        state.add_item_error = data;
    }
};

export {
    state,getters,actions,mutations
}


function updateItems(overall_discount){
    let data = state.data;
    $.each(state.data.data,(key,value)=>{
        let net_amount = 0;
        let price = parseFloat(value.price).toFixed(2);
        let net_price = parseFloat(value.price).toFixed(2);
        let rec = parseInt(value.rec);
        $.each(value.discount,(key1,value1)=>{
            let type = value1.type;
            let value = parseFloat(value1.value);
            let discount = 0;
            switch(type){
                case 'percent':
                    discount = net_price * value / 100;
                    net_price = net_price - discount;
                    break;
                case 'amount':
                    discount  = value;
                    net_price = net_price - discount;
                    break;
            }
        });
        net_amount = net_price * rec;
        $.each(overall_discount,(key1,value1)=>{
            let type = value1.type;
            let value = value1.value;
            let discount = 0;
            if(type!==''&&value!==''){
                switch(type){
                    case 'percent':
                        discount = net_amount * value / 100;
                        net_amount = net_amount - discount;
                        discount = discount / rec;
                        break;
                    case 'amount':
                        discount = value;
                        net_amount = net_amount - discount;
                        break;
                }
            }
        })
        if(rec!=0){
            net_price = net_amount / rec;
        }
        value.total_discount = parseFloat(price - net_price).toFixed(4);
        value.net_price = parseFloat(net_price).toFixed(4);
        let amount = value.net_price * rec;
        value.amount = parseFloat(amount).toFixed(2);
    });
    return data;
}